"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("./Flex"));

var _FlexUnit = _interopRequireDefault(require("./FlexUnit"));

var _theme = require("../../theme/theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Media = function Media(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "div" : _ref$as,
      _ref$asUnit = _ref.asUnit,
      asUnit = _ref$asUnit === void 0 ? "div" : _ref$asUnit,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "start" : _ref$align,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? null : _ref$start,
      _ref$end = _ref.end,
      end = _ref$end === void 0 ? null : _ref$end,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? "1" : _ref$space;
  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    as: as,
    align: align,
    justify: "start",
    wrap: false,
    space: space,
    className: className
  }, start && /*#__PURE__*/_react["default"].createElement(_FlexUnit["default"], {
    as: asUnit,
    grow: "0",
    shrink: "1",
    align: align
  }, start), children && /*#__PURE__*/_react["default"].createElement(_FlexUnit["default"], {
    as: asUnit,
    grow: "1",
    shrink: "1",
    align: align
  }, children), end && /*#__PURE__*/_react["default"].createElement(_FlexUnit["default"], {
    as: asUnit,
    grow: "0",
    shrink: "1",
    align: align
  }, end));
};

Media.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  start: _propTypes["default"].node,
  end: _propTypes["default"].node,
  as: _propTypes["default"].string,
  asUnit: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(_theme.FLEX_ALIGN_TYPES),
  space: _propTypes["default"].oneOf(_theme.SPACE_TYPES)
};
var _default = Media;
exports["default"] = _default;